import React from 'react';
import Pack from '../homes/Pack';
import PageHeader from '../ui/PageHeader';
import { useLanguage } from "../../i18n/LanguageContext";
import { Box } from '@mui/material';

const PackP = () => {
  const { t } = useLanguage();

  return (
    <Box sx={{ bgcolor: '#fff' }}>
      <PageHeader 
        title={t('common.packs')}
        subtitle={t('packs.subtitle')}
      />
      <Box sx={{ py: { xs: 8, md: 15 } }}>
        <Pack hideHeader={true} />
      </Box>
    </Box>
  );
}

export default PackP;